import type { ReactNode } from 'react';
import { Button } from './button';
import { Dialog } from './dialog';

/** A yes/no question before something destructive. Deletes in HELM go to Recently deleted. */
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Delete',
  onConfirm,
  onClose,
  loading,
  children,
}: {
  open: boolean;
  title: string;
  description: ReactNode;
  confirmLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
  loading?: boolean;
  children?: ReactNode;
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {children ?? <span />}
    </Dialog>
  );
}

export const RESTORE_NOTE = 'It moves to Recently deleted in Admin, where BlackWolf can restore it for 30 days.';
